import { Injectable } from '@angular/core';
import { KRONOS, MOC_API } from '../../../app-constants';
import { API } from '../../../constants/index';
import { DataService } from '../core/interceptor.service';

@Injectable({
  providedIn: 'root'
})

export class FeedbackCardService {

  constructor(private dataService: DataService) { }

  moodOfTheCrewFeedback(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOOD_OF_THE_CREW_FEEDBACK, req);
  }

  viewForms(){
    return this.dataService.get(KRONOS.BASE + KRONOS.ESAT + API.VIEW_FORMS);
  }

  viewFormById(id) {
    const req = {
      formId: id
    }
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.VIEW_FORM_BY_ID, req);
  }

  getMocAnalytics(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_STATISTICS, req);
  }

  checkFormResponse(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.FORM_RESPONSE, req);
  }

  getMoodOfTheCrewDetailedAnalytics(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOOD_OF_THE_CREW_ANALYTICS, req);
  }

  getMocDetailedResponses(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_DETAILED_RESPONSES, req);
  }

  getMocCategoryAnalytics(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_CATEGORY_ANALYTICS, req);
  }

  getMocCategoryTrend(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_CATEGORY_TREND, req);
  }

  getMocDashboardStats(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_DASHBOARD_STATS, req);
  }

  getMocProjectAnalytics(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_PROJECT_ANALYTICS, req);
  }

  getMocWeeklyTrends(req: any) {
    return this.dataService.post(KRONOS.BASE + KRONOS.ESAT + API.MOC_WEEKLY_TRENDS, req);
  }

  downloadMocReport(req: any) {
    return this.dataService.postBlob(KRONOS.BASE + KRONOS.ESAT + API.MOC_DOWNLOAD_REPORT, req);
  }

  getMocAiSummary(weekStartDate: string) {
    return this.dataService.getWithReqParams(MOC_API.BASE + 'moc/summary', { week_start_date: weekStartDate });
  }

  getMocImpacts(weekStartDate: string) {
    return this.dataService.getWithReqParams(MOC_API.BASE + 'moc/impact', { week_start_date: weekStartDate });
  }

  getDomains() {
    return this.dataService.get(MOC_API.BASE + 'admin/domains');
  }

  getQuestions(domainKey: string) {
    return this.dataService.getWithReqParams(MOC_API.BASE + 'admin/questions', { domain_key: domainKey });
  }

  addOption(questionId: number, optionText: string, displayOrder: number) {
    return this.dataService.post(MOC_API.BASE + 'admin/questions/' + questionId + '/options', {
      option_text: optionText,
      display_order: displayOrder,
      allows_other_text: false
    });
  }

  updateOption(id: number, optionText: string, displayOrder: number, isActive: boolean, allowsOtherText: boolean) {
    return this.dataService.patch(MOC_API.BASE + 'admin/options/' + id, {
      option_text: optionText,
      display_order: displayOrder,
      is_active: isActive,
      allows_other_text: allowsOtherText
    });
  }

  deleteOption(id: number) {
    return this.dataService.deletePlain(MOC_API.BASE + 'admin/options/' + id);
  }

  addMocImpact(impactText: string, createdBy: string) {
    return this.dataService.post(MOC_API.BASE + 'moc/impact', { impact_text: impactText, created_by: createdBy });
  }

  deleteMocImpact(id: string) {
    return this.dataService.deletePlain(MOC_API.BASE + 'moc/impact/' + id);
  }

}
